/**
 * The two groups of switches an admin's plan carries, as words.
 *
 * Both come from the legacy's `AdminDetail`. The backend stores them as free
 * JSON, so a key that is not here is shown with its raw name rather than
 * hidden: a capability added on the other side has to be visible — and
 * switchable — the day it appears, even if it reads oddly until someone names
 * it.
 */
export const SELLER_CHANNEL_LABELS = {
  mercado_libre: 'Mercado Libre',
  shopify: 'Shopify',
  woocommerce: 'WooCommerce',
  bootic: 'Bootic',
  vtex: 'VTEX',
  jumpseller: 'Jumpseller',
  bsale: 'Bsale',
};

export const ADDON_LABELS = {
  dashboard: 'Dashboard',
  dashboard_pro: 'Dashboard Pro',
  api_access: 'API Access',
  cx_support: 'CX Support',
  seller_channels_enabled: 'Seller Channels',
  fulfillment_lite: 'Fulfillment Lite',
  fulfillment_pro: 'Fulfillment Pro',
  wms_lite: 'Bodega (WMS) Lite',
  wms_pro: 'Bodega (WMS) Pro',
  pickup_points: 'Puntos de retiro',
  advanced_filter: 'Filtro avanzado',
};

/** The two editable groups of `admin_plan`, in the order the detail shows them. */
export const PLAN_GROUPS = [
  { field: 'seller_channels', title: 'Seller Channels', labels: SELLER_CHANNEL_LABELS },
  { field: 'addons', title: 'Addons', labels: ADDON_LABELS },
];
